import type { SVGProps } from 'react';
export const HelpOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M10 4.27a5.73 5.73 0 1 0 0 11.46 5.73 5.73 0 0 0 0-11.46M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0"
      clipRule="evenodd"
    />
    <path d="M10 14.11a.66.66 0 1 0 0-1.33.66.66 0 0 0 0 1.33" />
    <path
      fillRule="evenodd"
      d="M9.05 6.37a2.5 2.5 0 1 1 1.59 4.71.64.64 0 0 1-1.28-.02v-.53a.64.64 0 0 1 .64-.64 1.22 1.22 0 1 0-1.22-1.22.64.64 0 1 1-1.27 0 2.5 2.5 0 0 1 1.54-2.3"
      clipRule="evenodd"
    />
  </svg>
);
